import { Card, Skeleton } from "antd";
import { useRef, useState, useEffect } from "react";
import { useIntersection } from "react-use";

export function LazyWidget({
  children,
  rootMargin = "-20px",
  minHeight = 260,
  placeholder,
  style,
  onVisible,
}: {
  children: React.ReactNode;
  rootMargin?: string;
  minHeight?: number;
  placeholder?: React.ReactNode;
  style?: React.CSSProperties;
  onVisible?: () => void;
}) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const entry = useIntersection(containerRef, { rootMargin, threshold: 0 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (entry?.isIntersecting) {
      setVisible(true);
      onVisible?.();
    }
  }, [entry, onVisible]);

  const mergedStyle = {
    width: "100%",
    minHeight,
    height: "100%",
    ...style,
  };

  return (
    <div ref={containerRef} style={mergedStyle}>
      {visible
        ? children
        : placeholder || (
            <Card
              style={{ height: "100%", position: "relative" }}
              styles={{ body: { height: "100%" } }}
              className="rounded"
            >
              <Skeleton
                active
                style={{ minHeight, height: mergedStyle.height }}
              />
            </Card>
          )}
    </div>
  );
}
